import { EMAIL_VALIDATOR } from "helpers/validators";

const sendMailToVerifyFields = {
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "UserName",
    placeholder: "login-user-email-placeholder",
    label: "incomplete-verify-email-text",
    disabled: true,
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
  },
};

export default sendMailToVerifyFields;
